import { Observable } from 'rxjs';
import { IAssignScopesRequest } from '../dtos/requests/assign-scopes.request';
import { ICreateAccountRequest } from '../dtos/requests/create-account.request';
import { IRevokeScopesRequest } from '../dtos/requests/revoke-scopes.request';
import { IUpdateAccountRequest } from '../dtos/requests/update-account.request';
import { AccountsListApiResponse, IAccount } from '../dtos/responses/accounts-list-response';
import { ICreateAccountResponse } from '../dtos/responses/create-account.response';
import { IAccountsApiClient } from './i-accounts-api.client';
import { CollectionApiClient } from '../../../../core/data-access/http-client/clients/api-client-service';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserManagementCollections } from '../../../common/collections/user-management.collections';
import { IPaginationParameters } from '../../../../core/data-access/pagination/interfaces/pagination-parameters.interface';
import { ICreateAddressReqeust, ILookup } from '../../../../core';
import { IValidateUserRequest } from '../../users';
import { IAccountsPaginationParameters, IValidateAccountRequest } from '../dtos';

@Injectable({
  providedIn: 'root'
})
export class AccountsApiClient implements IAccountsApiClient {
  public http = inject(HttpClient);
  private collectionApiClient = CollectionApiClient.create(UserManagementCollections.Accounts, this.http);

  get(paginationParameters?: IAccountsPaginationParameters): Observable<AccountsListApiResponse> {
    return this.collectionApiClient.get({ paginationParameters });
  }

  create(body: ICreateAccountRequest): Observable<ICreateAccountResponse> {
    return this.collectionApiClient.post({ body });
  }

  addHeadQuarterAddress(id: string, body: ICreateAddressReqeust): Observable<void> {
    return this.collectionApiClient.patch({ id, body });
  }

  getById(id: string): Observable<IAccount> {
    return this.collectionApiClient.get({ id });
  }

  update(id: string, body: IUpdateAccountRequest): Observable<void> {
    return this.collectionApiClient.patch({ id, body });
  }

  getScopes(id: string): Observable<ILookup<string>[]> {
    return this.collectionApiClient.get({
      collectionName: UserManagementCollections.AccountScopes(id)
    });
  }
  assignScopes(id: string, body: IAssignScopesRequest): Observable<void> {
    return this.collectionApiClient.post({
      body,
      collectionName: UserManagementCollections.AccountScopes(id)
    });
  }

  revokeScopes(id: string, body: IRevokeScopesRequest): Observable<void> {
    return this.collectionApiClient.delete({
      body,
      collectionName: UserManagementCollections.AccountScopes(id)
    });
  }

  accountValidation(body: IValidateAccountRequest): Observable<void> {
    return this.collectionApiClient.post({ body , collectionName: UserManagementCollections.AccountValidation()});
  }

  adminAccountValidation(body: IValidateUserRequest): Observable<void> {
    return this.collectionApiClient.post({ body, collectionName: UserManagementCollections.AdminAccountValidation() });
  }
}
